module.exports = __webpack_public_path__ + "fontawesome-webfont.674f50d287a8c48dc19b.eot";


//////////////////
// WEBPACK FOOTER
// F:/SVNNew/Web/Phoenix Website/Website_Admin/src/assets/vendors/by_hands/font-awesome/fonts/fontawesome-webfont.eot
// module id = ../../../../../src/assets/vendors/by_hands/font-awesome/fonts/fontawesome-webfont.eot
// module chunks = styles